import { DreamValue, TodoListElement as TodoListElementType } from '@typedream/core';
import { isBlock, PluginOptions, setNodes } from '@udecode/plate-core';
import { createAutoformatPlugin } from '@udecode/plate-autoformat';
import { TodoListElement } from '@typedream/components';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_OL, ELEMENT_TODO_LI, ELEMENT_UL } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { BaseDreamEditor } from '../../types';
import { autoFormatQuery } from './queries/autoformat';

const createTodoListAutoFormatterPlugin = () =>
  createAutoformatPlugin<PluginOptions, DreamValue, BaseDreamEditor>({
    key: 'autoformat-todo-list',
    options: {
      rules: [
        {
          mode: 'block',
          type: ELEMENT_TODO_LI,
          match: '[] ',
          query: autoFormatQuery,
        },
        {
          mode: 'block',
          type: ELEMENT_TODO_LI,
          match: '[x] ',
          query: autoFormatQuery,
          format: (editor: any) =>
            setNodes<TodoListElementType>(
              editor,
              { type: ELEMENT_TODO_LI, checked: true },
              {
                match: (n) => isBlock(editor, n),
              }
            ),
        },
      ],
    },
  });

export const createTodoListPlugin = createTElementPluginFactory({
  key: ELEMENT_TODO_LI,
  component: withDropTarget(TodoListElement),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/todo_list.png',
      title: 'To-do List',
      subtitle: 'Add tasks with a to-do list',
      keywords: ['todo', 'list'],
    },
    format: {
      formatType: 'block',
      turnInto: [ELEMENT_UL, ELEMENT_OL, ELEMENT_TODO_LI],
      focusableWhenEmpty: true,
      changeToParagraphOnBackspace: true,
      validProperties: ['width', 'width_max', 'checked', 'mobile_hide', 'desktop_hide'],
    },
  },
  plugins: [createTodoListAutoFormatterPlugin()],
});
